import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import PaymentNoticeComponent from './payment-notice.component';

let PaymentNoticeModule = angular
  .module('PaymentNotice', [
    uiRouter
  ])
  .component('paymentNotice', PaymentNoticeComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('paymentNotice', {
      views: {
        'menu': "",
        'content': {
          component: 'paymentNotice'
        }
      }
    })
  })
  .name;

export default PaymentNoticeModule;



// WEBPACK FOOTER //
// ./src/app/pages/payment-notice/payment-notice.module.js